import { render, staticRenderFns } from "./pdf-viewer.vue?vue&type=template&id=5df0a9ba&"
import script from "./pdf-viewer.vue?vue&type=script&lang=ts&"
export * from "./pdf-viewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports